import { render, staticRenderFns } from "./mobilize.vue?vue&type=template&id=605d4075&scoped=true&"
import script from "./mobilize.vue?vue&type=script&lang=js&"
export * from "./mobilize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605d4075",
  null
  
)

export default component.exports